module.exports = __webpack_public_path__ + "static/media/watson.20e79373.jpg";